import i18n from "../i18n";
// export const getResults = async (task_id: any, token: string) => {
//   try {
//     const response = await fetch(
//       `${process.env.REACT_APP_BASE_URL}/task/task-result/${task_id}`,
//       {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Accept-Language": i18n.language,
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error("Failed to fetch task results");
//     }

//     const data = await response.json();
//     console.log("Task Result:", data);
//     return data.data;
//   } catch (error) {
//     console.error("Error fetching task results:", error);
//     throw error;
//   }
// };
export const getSfaData = async (
  token: string,
  month?: string,
  year?: string,
  contactOrAccountId?: string   // 👈 new optional param
) => {
  try {
    const now = new Date();
    const apiMonth = (month ? month.slice(0, 3) : now.toLocaleString("en-US", { month: "short" }))
      .toLowerCase();
    const apiYear = year || String(now.getFullYear());

    const qs = new URLSearchParams({
      month: apiMonth,
      year: apiYear,
    });

    // send as both to satisfy current BE expectation
    if (contactOrAccountId) {
      // qs.append("contact_id", contactOrAccountId);
      qs.append("account_id", contactOrAccountId);
      console.log("✅ Using contactOrAccountId as account_id:", contactOrAccountId);
    }

    const url = `${process.env.REACT_APP_BASE_URL}/import-csv/get-sfa-data?${qs.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("❌ Error fetching SFA data:", error);
    return null;
  }
};

export const getDailySurveyOverview = async (
  token: string,
  contactOrAccountId: string,
  month?: string,
  year?: string
) => {
  try {
    const now = new Date();
    const apiMonth = (month ? month.slice(0, 3) : now.toLocaleString("en-US", { month: "short" }))
      .toLowerCase();
    const apiYear = year || String(now.getFullYear());

    const qs = new URLSearchParams({
      account_id: contactOrAccountId,
      month: apiMonth,
      year: apiYear,
    });

    const url = `${process.env.REACT_APP_BASE_URL}/import-csv/get-daily-survey-overview?${qs.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("❌ Error fetching daily survey overview:", error);
    return null;
  }
};

export const getResults = async (
  task_id: string | number,
  token: string,
  userAgent?: string,
  latitude?: number | string,
  longitude?: number | string,
  device_os_version?: string,
  browser_name?: string,
  browser_version?: string,
  notification_consent_status?: string,
  location_consent_status?: string,
  page_name?: string
) => {
  const finalLatitude = latitude || localStorage.getItem("latitude") || "";
  const finalLongitude = longitude || localStorage.getItem("longitude") || "";
  const tokenn = localStorage.getItem("token");
  const finalLocationConsent =
    finalLatitude && finalLongitude ? "1" : location_consent_status || "0";

  const storedNotificationStatus = localStorage.getItem("notification_consent_status");
  const normalizedNotificationStatus =
    notification_consent_status === "1" || storedNotificationStatus === "1" ? "1" : "0";

  const finalPageName = getPageNameWithFallback(page_name);

  const headers: Record<string, string> = {
    Authorization: `Bearer ${tokenn}`,
    "Accept-Language": i18n.language,
    "Content-Type": "application/json",
    "User-Agent": userAgent || navigator.userAgent,
    latitude: String(finalLatitude),
    longitude: String(finalLongitude),
    "device-os-version": device_os_version || "abc",
    "browser-name": browser_name || "bn",
    "browser-version": browser_version || "bv",
    "notification-consent-status": normalizedNotificationStatus,
    "location-consent-status": finalLocationConsent,
    "page-name": finalPageName,
  };

  console.log("✅ Sending headers to getResults API:", headers);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/task/task-result/${task_id}`,
      {
        method: "GET",
        headers,
      }
    );

    if (!response.ok) throw new Error("Failed to fetch task results");

    const data = await response.json();
    console.log("Task Result:", data);
    return data.data;
  } catch (error: unknown) {
    console.error("Error fetching task results:", error);
    throw error;
  }
};
export const getPageNameWithFallback = (page_name?: string): string => {
  // First try the passed parameter
  if (page_name && page_name !== "unknown" && page_name !== "null" && page_name !== "undefined") {
    return page_name;
  }

  // Try localStorage
  try {
    const storedPageName = localStorage.getItem("page_name");
    if (storedPageName && storedPageName !== "null" && storedPageName !== "undefined") {
      return storedPageName;
    }
  } catch (error) {
    console.warn("⚠️ localStorage access failed:", error);
  }

  // Try sessionStorage as fallback for iOS
  try {
    const sessionPageName = sessionStorage.getItem("page_name");
    if (sessionPageName && sessionPageName !== "null" && sessionPageName !== "undefined") {
      return sessionPageName;
    }
  } catch (error) {
    console.warn("⚠️ sessionStorage access failed:", error);
  }

  // Try to get from window.location for iOS
  try {
    if (window.location && window.location.href) {
      return window.location.href;
    }
  } catch (error) {
    console.warn("⚠️ window.location access failed:", error);
  }

  // Try memory fallback (for iOS when storage fails)
  try {
    const memoryPageName = (window as any).__pageName;
    if (memoryPageName && memoryPageName !== "null" && memoryPageName !== "undefined") {
      return memoryPageName;
    }
  } catch (error) {
    console.warn("⚠️ memory fallback access failed:", error);
  }

  // Final fallback
  return "unknown";
};

export const getsession = async (
  queryparams: string,
  userAgent?: string,
  latitude?: number | string,
  longitude?: number | string,
  device_os_version?: string,
  browser_name?: string,
  browser_version?: string,
  notification_consent_status?: string,
  location_consent_status?: string,
  page_name?: string,
  task_id?: number | string, // ✅ accept string also
) => {
  const url = new URL(`${process.env.REACT_APP_BASE_URL}/auth/get-session-data`);
  url.searchParams.set("encryptedData", queryparams);

  if (latitude !== undefined) url.searchParams.set("latitude", String(latitude));
  if (longitude !== undefined) url.searchParams.set("longitude", String(longitude));

  const finalLocationConsent = latitude && longitude ? "1" : location_consent_status || "0";

  const storedNotificationStatus = localStorage.getItem("notification_consent_status");
  const normalizedNotificationStatus =
    notification_consent_status === "1" || storedNotificationStatus === "1" ? "1" : "0";

  // ✅ Get page name with iOS-specific fallbacks
  const finalPageName = getPageNameWithFallback(page_name);
  
  // Log for debugging
  console.log("🔍 Page name resolution:", {
    passedPageName: page_name,
    finalPageName,
    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
    localStorageValue: localStorage.getItem("page_name"),
    sessionStorageValue: sessionStorage.getItem("page_name")
  });

  // ✅ Extract task_id from URL if present
  let decodedTaskId = task_id || "";
  try {
    const urlObj = new URL(finalPageName);
    const taskIdParam = urlObj.searchParams.get("task_id");
    if (taskIdParam) {
      decodedTaskId = window.atob(taskIdParam); // Base64 decode
      console.log("🔍 Extracted and decoded task_id:", decodedTaskId);
    }
  } catch (err) {
    console.warn("⚠️ Unable to extract task_id from page_name:", err);
  }

  const headers: Record<string, string> = {
    "user-agent": userAgent || "",
    "device-os-version": device_os_version || "",
    "browser-name": browser_name || "",
    "browser-version": browser_version || "",
    "notification-consent-status": normalizedNotificationStatus,
    "location-consent-status": finalLocationConsent,
    "page-name": finalPageName,
    "task_id": decodedTaskId ? String(decodedTaskId) : "",
  };

  console.log("✅ Sending headers to getsession API:", headers);

  try {
    const response = await fetch(url.toString(), { method: "GET", headers });
    const result = await response.json();
    console.log("Session result:", result);
    return result;
  } catch (err: unknown) {
    console.error(err);
    throw new Error(err instanceof Error ? err.message : "Something went wrong");
  }
};




// export const getsession = async (queryparams: any, userAgent?: any) => {
//   return await fetch(
//     `${
//       process.env.REACT_APP_BASE_URL
//     }/auth/get-session-data?encryptedData=${encodeURIComponent(queryparams)}`,
//     {
//       method: "get",
//       headers: {
//         "user-agent": userAgent,
//       },
//     }
//   )
//     .then((response) => response.json())
//     .then((result: any) => {
//       console.log("imgg", result);
//       return result;
//     })
//     .catch((error) => {
//       console.error(error);
//       throw new Error(error?.message || "Something went wrong");
//     });
// };
export const getTaskDetails = async (accId: any) => {
  return await fetch(
    `${process.env.REACT_APP_BASE_URL}/task/fetch-tasks?account_id=${accId}`,
    {
      method: "GET",
      headers: {
        "Accept-Language": i18n.language,
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((result: any) => {
      console.log("imgg", result);
      return result;
    })
    .catch((error) => {
      console.error(error);
      throw new Error(error?.message || "Something went wrong");
    });
};
export const getBannerDetails = async (data: any, token: string) => {
  return await fetch(
    `${process.env.REACT_APP_BASE_URL}/barnd_banner/get_brand_banner_details_city`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Accept-Language": i18n.language,
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((result: any) => {
      console.log("imgg", result);
      return result;
    })
    .catch((error) => {
      console.error(error);
      throw new Error(error?.message || "Something went wrong");
    });
};

export const getTaskList = async (token: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/task/get-tasks-v1`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
     "Accept-Language": i18n.language,
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to fetch task results");
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching task results:", error);
    throw error;
  }
};
export const getIRTaskResult = async (token: string, publish_id:string,lang?: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/task/get-ir-task-result/${publish_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": lang ? lang : i18n.language,
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to fetch task results");
    //  return {"data": [
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/E5A94C8E-4746-4897-B41D-F36EC8E6C812_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/1ed5ac81-5285-49a9-8251-ff9121952bfb_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "success"
    //         },
    //         "result_failure": ""
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/1e232e90-f635-469f-952a-8334d70fb851_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/0d0cf46d-084e-44bb-9f0a-e3a82898d8e9_1.jpg",
    //             "image_validity": "Invalid",
    //             "reason": "Blurred Image",
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/ec8a9dc2-0d07-4889-a71b-7e4ba0caca98_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/33d851f1-8d9c-468e-97ef-6875c086e5c6_1.jpg",
    //             "image_validity": "Invalid",
    //             "reason": "Blurred Image",
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/f23cb500-ebf3-4bff-b4a1-8a156265c82c_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "success"
    //         },
    //         "result_failure": ""
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/5089E28F-109F-42BE-ACA1-12E6BD5F559E_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "fail"
    //         }
    //     }
    // ]}
    }
    const data = await response.json();
    return data
    // return {
    //   "data": [
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/E5A94C8E-4746-4897-B41D-F36EC8E6C812_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/1ed5ac81-5285-49a9-8251-ff9121952bfb_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "success"
    //         },
    //         "result_failure": ""
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/1e232e90-f635-469f-952a-8334d70fb851_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/0d0cf46d-084e-44bb-9f0a-e3a82898d8e9_1.jpg",
    //             "image_validity": "Invalid",
    //             "reason": "Blurred Image",
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/ec8a9dc2-0d07-4889-a71b-7e4ba0caca98_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/33d851f1-8d9c-468e-97ef-6875c086e5c6_1.jpg",
    //             "image_validity": "Invalid",
    //             "reason": "Blurred Image",
    //             "status": "fail"
    //         }
    //     },
    //     {
    //         "result_success": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/f23cb500-ebf3-4bff-b4a1-8a156265c82c_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "success"
    //         },
    //         "result_failure": ""
    //     },
    //     {
    //         "result_success": "",
    //         "result_failure": {
    //             "image_url": "https://storage.googleapis.com/pd-sw-prod-us-core-sw2/dist/test_images_modified/0fe55f6d-ef45-45af-9385-4e2e25dc56b2_169916/5089E28F-109F-42BE-ACA1-12E6BD5F559E_1.jpg",
    //             "image_validity": "Valid",
    //             "reason": null,
    //             "status": "fail"
    //         }
    //     }
    // ]
    // };
  } catch (error) {
    console.error("Error fetching task results:", error);
    throw error;
  }

  
};
export const getMonthlyDetail = async (
  token: string,
  taskId?: string | number,
  month?: string | number,
  year?: string | number,
  language?: string
  // language: string = "en"  // optional, defaults to 'en'
): Promise<any> => {
  try {
    if (!token) throw new Error("token is required");

    const now = new Date();
    const apiMonth = month
      ? (typeof month === "string" ? month.slice(0, 3) : String(month)).toLowerCase()
      : now.toLocaleString("en-US", { month: "short" }).toLowerCase();
    const apiYear = year ? String(year) : String(now.getFullYear());

    const qs = new URLSearchParams({
      month: apiMonth,
      year: apiYear,
    });

    if (taskId !== undefined && taskId !== null) {
      qs.append("taskId", String(taskId));
    }

    const url = `${process.env.REACT_APP_BASE_URL}/task/get-detail-monthly?${qs.toString()}`;
//  const languageToUse = language || (i18n && i18n.language) || "en_IN";
    const response = await fetch(url, {
     
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
       "Accept-Language": i18n.language,  
      "x-language": i18n.language,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Error fetching monthly detail:", error);
    return null;
  }
};


export const createDailySurvey = async (payload: any[]) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token is required");

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/import-csv/create-daily-survey`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload), // ✅ IMPORTANT
      }
    );

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    return await response.json();
  } catch (error) {
    console.error("Error creating daily survey:", error);
    throw error;
  }
};


    export const getDailySurveyData = async (
  token: string,
  month?: string,
  year?: string,
  day?: number,
  contactOrAccountId?: string   // 👈 new optional param
) => {
  try {
    const now = new Date();
    const apiMonth = (month ? month.slice(0, 3) : now.toLocaleString("en-US", { month: "short" }))
      .toLowerCase();
    const apiYear = year || String(now.getFullYear());
    const apiDay = day ?? now.getDate();
        const qs = new URLSearchParams({
          month: apiMonth,
          year: apiYear,
          day: String(apiDay), 
        })
    

    // send as both to satisfy current BE expectation
    if (contactOrAccountId) {
      // qs.append("contact_id", contactOrAccountId);
      qs.append("account_id", contactOrAccountId);
      console.log("✅ Using contactOrAccountId as account_id:", contactOrAccountId);
    }

    const url = `${process.env.REACT_APP_BASE_URL}/import-csv/get-daily-survey-packcount?${qs.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("❌ Error fetching SFA data:", error);
    return null;
  }
};